import { createSlice } from "@reduxjs/toolkit";
import { initialPaymentStatusPopupState } from "./paymentStatusPopupConstant";

const paymentStatusPopupSlice = createSlice({
    name: 'paymentStatusPopup',
    initialState: initialPaymentStatusPopupState,
    reducers: {
        setShowPaymentStatusPopup(state, action) {
            state.isVisible = true;

            let payload = action.payload || {};
            let configObj = payload.configObj || {};
            let onConfirmKey = payload.onConfirmKey || null;
            let onCancelKey = payload.onCancelKey || null;

            let title = configObj.TITLE || '';
            let icon = configObj.ICON || '';
            let variant = configObj.VARIANT || '';
            let message = configObj.MESSAGE || '';
            let confirmBtnText = configObj.CONFIRM_BTN_TEXT || '';
            let cancelBtnText = configObj.CANCEL_BTN_TEXT || '';
            let textWhileProcessingConfirmBtn = configObj.TEXT_WHILE_PROCESSING_CONFIRM_BTN || '';
            let textWhileProcessingCancelBtn = configObj.TEXT_WHILE_PROCESSING_CANCEL_BTN || '';

            state.config = {
                ...state.config,
                title,
                icon,
                variant,
                message,
                confirmBtnText,
                cancelBtnText,
                textWhileProcessingConfirmBtn,
                textWhileProcessingCancelBtn,
                onConfirmKey,
                onCancelKey
            };
        },
        clearPaymentStatusPopup(state) {
            state.isVisible = false;
            state.config = initialPaymentStatusPopupState.config;
        },
        toggleConfirmBtnLoading(state, action) {
            state.config.confirmBtnLoading = action.payload;
        },
        toggleCancelBtnLoading(state, action) {
            state.config.cancelBtnLoading = action.payload;
        }
    }
})

export const {
    setShowPaymentStatusPopup,
    clearPaymentStatusPopup,
    toggleConfirmBtnLoading,
    toggleCancelBtnLoading
} = paymentStatusPopupSlice.actions;

export default paymentStatusPopupSlice.reducer;